"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports["default"] = exports.MARKETING = exports.Header = exports.DTC = exports.CUSTOM = exports.B2B = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _makeStyles = _interopRequireDefault(require("../styles/makeStyles"));

var _Grid = _interopRequireDefault(require("../Grid"));

var _TrackingLink = _interopRequireDefault(require("../TrackingLink"));

var _Nav = _interopRequireDefault(require("./Nav"));

var _NavMobile = _interopRequireDefault(require("./NavMobile"));

var _SiteLinks = require("../Footer/SiteLinks");

var _EmailUs = require("../Footer/EmailUs");

var _SocialLinks = require("../Footer/SocialLinks");

var _theme = require("../utils/theme");

var EarnUpLogoWhite = function EarnUpLogoWhite(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("title", null, "Group 17"), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("path", {
    id: "a",
    d: "M.08.044h9.94V15.74H.08z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    id: "c",
    d: "M0 .071h9.68v11.483H0z"
  })), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M61.612 0l-.085.163c-.052.109-.142.263-.27.464-.261.392-.65.971-1.235 1.635a27.037 27.037 0 0 1-2.233 2.29c-.92.829-2.01 1.71-3.256 2.6-1.249.885-2.665 1.757-4.206 2.607-1.546.843-3.232 1.628-5.008 2.368l-1.357.524-.688.26-.701.24c-.469.159-.94.32-1.415.48l-1.447.43-.729.215-.737.193-1.483.378c-.997.228-2.001.445-3.007.648-2.02.366-4.048.684-6.057.883-1.005.096-2 .214-2.987.255l-1.47.087-.728.04-.723.015-1.426.029c-.47.006-.937.028-1.398.012l-2.703-.053c-.877-.033-1.73-.089-2.553-.137l-1.214-.077-1.166-.11-2.183-.222c-.692-.081-1.346-.178-1.96-.264-.615-.09-1.19-.168-1.72-.253-.53-.08-1.014-.182-1.453-.258-.876-.157-1.561-.304-2.029-.393l-.715-.15.731-.002c.476.005 1.176-.003 2.06.017.885.028 1.962.01 3.192.012.616-.004 1.269.015 1.958.004l2.167-.034 1.154-.01 1.197-.044c.811-.033 1.65-.041 2.51-.084l2.644-.14c.9-.056 1.818-.134 2.752-.201 1.865-.153 3.786-.352 5.729-.604a103.37 103.37 0 0 0 5.852-.931c.973-.189 1.943-.39 2.906-.602.954-.245 1.922-.43 2.855-.702 1.89-.478 3.707-1.068 5.465-1.65 1.74-.624 3.411-1.263 4.959-1.954a57.285 57.285 0 0 0 4.28-2.118 48.905 48.905 0 0 0 3.452-2.104c.993-.68 1.838-1.31 2.508-1.863A19.217 19.217 0 0 0 61.133.534c.158-.168.285-.298.36-.393l.12-.141M48.715 23.407v7.327c0 1.32-.837 2.178-2.198 2.178H45.51c-1.36 0-2.198-.859-2.198-2.178v-7.327h-1.78v7.117c0 2.325.88 3.957 3.728 3.957h1.507c2.848 0 3.727-1.632 3.727-3.957v-7.117h-1.78z",
    fill: "#FFF"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(52.861 23.026)"
  }, /*#__PURE__*/_react["default"].createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/_react["default"].createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.05 10.104c-2.374 0-3.308-2.03-3.308-4.232 0-2.094.894-4.21 3.207-4.21 2.232 0 3.246 2.03 3.246 4.124 0 2.18-.791 4.318-3.144 4.318M5.19.044c-1.44 0-2.778.54-3.347 1.77h-.04V.302H.08v15.436h1.724V9.974h.04c.771 1.317 2.313 1.749 3.39 1.749 3.204 0 4.786-2.656 4.786-5.807 0-3.152-1.602-5.872-4.828-5.872",
    fill: "#FFF",
    mask: "url(#b)"
  })), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(0 23.026)"
  }, /*#__PURE__*/_react["default"].createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/_react["default"].createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.326 5.056c.21-1.978 1.408-3.87 3.575-3.87 2.146 0 3.386 1.872 3.449 3.87H1.326zM4.901.07C1.45.071 0 2.953 0 5.812c0 3.093 1.451 5.742 4.9 5.742 2.735 0 4.165-1.43 4.733-3.89H8.308c-.421 1.64-1.473 2.775-3.407 2.775-2.545 0-3.555-2.334-3.575-4.269h8.349C9.78 3.12 8.392.071 4.9.071z",
    fill: "#FFF",
    mask: "url(#d)"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24.544 25.956h-.042v-2.544h-1.22v10.853h1.325V28.48c0-2.251 1.641-4.018 4.037-3.891v-1.325c-1.954-.085-3.427.947-4.1 2.691M35.293 23.097c-1.536 0-2.988.883-3.471 2.186h-.042v-1.871h-1.325v10.853h1.325v-6.33c.042-2.125 1.303-3.723 3.408-3.723 2.145 0 2.754 1.408 2.754 3.28v6.773h1.325V27.28c0-2.586-.925-4.184-3.974-4.184M19.077 30.12h-.001v.042c-.003.189.001.87.001 1.075 0 1.786-1.283 2.228-2.84 2.228h-.946c-1.241 0-2.418-.82-2.418-2.145a2.062 2.062 0 0 1 .068-.53c.004-.016.008-.032.014-.048a1.542 1.542 0 0 1 .21-.436l.03-.041a1.723 1.723 0 0 1 .393-.384l.003-.002a2.46 2.46 0 0 1 .378-.227l.065-.03c.046-.022.092-.044.14-.064l.112-.043a.152.152 0 0 1 .027-.01c.04-.016.082-.03.124-.045a3.057 3.057 0 0 0 .077-.025 1.62 1.62 0 0 1 .126-.04c.054-.015.11-.03.166-.047.064-.017.127-.034.193-.049.062-.015.124-.03.187-.043.194-.043.396-.08.601-.115.202-.034.406-.065.613-.095l.242-.034.345-.05.07-.01c.114-.015.226-.032.337-.05.105-.015.21-.031.314-.049l.213-.035c.356-.064.946-.169 1.114-.485h.042v1.788zm-.001-6.394a4.915 4.915 0 0 0-.144-.088 4.97 4.97 0 0 0-.148-.08 4.976 4.976 0 0 0-.31-.136 2.06 2.06 0 0 0-.132-.047 1.032 1.032 0 0 0-.086-.03 3.743 3.743 0 0 0-.244-.07c-.045-.011-.09-.023-.135-.031a5.06 5.06 0 0 0-.586-.1 6.954 6.954 0 0 0-.475-.037 7.803 7.803 0 0 0-1.57.08c-.031.005-.063.01-.094.018a1.687 1.687 0 0 0-.117.021c-.052.01-.102.02-.15.034a3.185 3.185 0 0 0-.168.04l-.037.01a8.104 8.104 0 0 0-.367.118 3.888 3.888 0 0 0-.515.23c-.047.026-.095.052-.14.08l-.064.038a3.163 3.163 0 0 0-.524.403l-.031.03c-.03.029-.058.057-.084.086a2.51 2.51 0 0 0-.267.32 2.207 2.207 0 0 0-.097.14c-.018.03-.038.06-.057.093a2.776 2.776 0 0 0-.128.234l-.015.033a2.268 2.268 0 0 0-.066.147c-.004.01-.008.018-.01.027-.019.04-.034.082-.049.124a1.13 1.13 0 0 0-.04.116c-.006.015-.012.029-.014.043a1.57 1.57 0 0 0-.036.118c-.013.044-.025.088-.036.133l-.009.037a2.945 2.945 0 0 0-.045.216c-.01.052-.018.103-.026.157-.004.017-.005.033-.008.05a5.9 5.9 0 0 0-.042.452h1.325c.003-.101.009-.199.019-.292.003-.028.005-.056.011-.084a.849.849 0 0 1 .013-.09v-.008c.007-.048.016-.096.027-.142.008-.04.018-.08.028-.118l.008-.03c.01-.04.022-.08.036-.12 0-.004.002-.007.003-.011a3.03 3.03 0 0 1 .097-.244 2.037 2.037 0 0 1 .414-.607c.007-.008.013-.015.02-.02a1.42 1.42 0 0 1 .083-.078.985.985 0 0 1 .094-.08c.032-.025.065-.051.1-.074.032-.025.067-.046.101-.07a2.483 2.483 0 0 1 .5-.24c.043-.017.087-.033.132-.046l.109-.033a3.65 3.65 0 0 1 .447-.09c.022-.005.045-.007.067-.01.142-.019.29-.029.441-.033.05-.003.1-.003.153-.003 1.556 0 2.84.441 2.84 2.228a1.968 1.968 0 0 1-.125.745.82.82 0 0 1-.088.161c-.012.019-.025.036-.038.053a.834.834 0 0 1-.206.189 1.229 1.229 0 0 1-.255.13 1.53 1.53 0 0 1-.113.038c-.027.009-.055.017-.084.024l-.067.018-.019.004a1.784 1.784 0 0 1-.147.03 2.943 2.943 0 0 1-.267.043c-.094.013-.193.026-.295.038l-.587.067-.382.043c-.065.006-.13.015-.195.022a32.87 32.87 0 0 0-.864.114l-.09.013a12.232 12.232 0 0 0-1.072.213 9.71 9.71 0 0 0-.428.122 14.012 14.012 0 0 0-.204.07l-.026.01a4.773 4.773 0 0 0-.554.252 3.168 3.168 0 0 0-.588.414 2.564 2.564 0 0 0-.266.285 2.098 2.098 0 0 0-.177.255 2.49 2.49 0 0 0-.22.476 3.13 3.13 0 0 0-.157.762c-.001.013-.003.026-.003.04a1.79 1.79 0 0 0-.005.091 1.14 1.14 0 0 0-.005.1c-.001.047-.003.094-.003.142 0 2.188 1.64 3.176 3.638 3.176h1.22c.94 0 1.917-.141 2.67-.629.785-.503 1.326-1.382 1.326-2.862v-4.501c0-1.48-.541-2.359-1.326-2.862z",
    fill: "#FFF"
  })));
};

EarnUpLogoWhite.defaultProps = {
  width: "64",
  height: "40",
  viewBox: "0 0 64 40",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};

var EarnUpLogoDTC = function EarnUpLogoDTC(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("title", null, "EarnUpLogo Footer"), /*#__PURE__*/_react["default"].createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M125.4.01s-.06.11-.17.33a10 10 0 0 1-.55.94c-.53.8-1.32 1.98-2.51 3.33a56.141 56.141 0 0 1-4.54 4.66c-1.87 1.69-4.09 3.48-6.63 5.29-2.54 1.8-5.42 3.58-8.56 5.31-3.14 1.72-6.58 3.31-10.19 4.82-.91.35-1.83.71-2.76 1.07-.47.18-.93.35-1.4.53-.47.16-.95.32-1.43.49-.95.32-1.91.65-2.88.98l-2.94.87-1.48.44-1.5.39c-1 .26-2.01.51-3.02.77-2.03.46-4.07.9-6.12 1.32-4.11.74-8.24 1.39-12.33 1.8-2.04.2-4.07.43-6.08.52l-2.99.18c-.49.03-.99.05-1.48.08l-1.47.03-2.9.06c-.96.01-1.91.06-2.85.02-1.88-.04-3.71-.07-5.5-.11-1.79-.07-3.52-.18-5.2-.28-.84-.05-1.66-.11-2.47-.16-.81-.08-1.6-.15-2.37-.23-1.55-.16-3.03-.31-4.44-.45-1.41-.16-2.74-.36-3.99-.54-1.25-.18-2.42-.34-3.5-.52-1.08-.16-2.06-.37-2.96-.53-1.78-.32-3.18-.62-4.13-.8-.95-.2-1.46-.3-1.46-.3s.52 0 1.49-.01c.97.01 2.39-.01 4.19.04 1.8.06 3.99.02 6.49.02 1.25-.01 2.58.03 3.98.01 1.4-.02 2.87-.04 4.41-.07.77-.01 1.55-.01 2.35-.02l2.44-.09c1.65-.07 3.36-.08 5.11-.17 1.75-.09 3.54-.19 5.38-.29 1.83-.11 3.7-.27 5.6-.41 3.8-.31 7.71-.72 11.66-1.23s7.94-1.15 11.91-1.9c1.98-.38 3.95-.79 5.91-1.23 1.94-.5 3.91-.87 5.81-1.43 3.84-.97 7.54-2.17 11.12-3.36 3.54-1.27 6.94-2.57 10.09-3.98 3.14-1.41 6.08-2.85 8.71-4.31 2.63-1.46 4.99-2.91 7.02-4.28 2.02-1.38 3.74-2.67 5.1-3.79 1.36-1.13 2.38-2.08 3.04-2.76.32-.34.58-.61.73-.8.17-.15.26-.25.26-.25z",
    fill: "#33BB80"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M99.15 47.64v14.91c0 2.68-1.7 4.43-4.47 4.43h-2.05c-2.77 0-4.47-1.75-4.47-4.43V47.64h-3.62v14.48c0 4.73 1.79 8.05 7.58 8.05h3.07c5.8 0 7.58-3.32 7.58-8.05V47.64h-3.62zM118.15 46.95c-2.93 0-5.66 1.1-6.81 3.6h-.08v-3.07h-3.51v31.41h3.51V67.16h.08c1.57 2.68 4.71 3.56 6.9 3.56 6.52 0 9.74-5.4 9.74-11.82s-3.26-11.95-9.83-11.95zm-.28 20.48c-4.83 0-6.73-4.13-6.73-8.61 0-4.26 1.82-8.57 6.52-8.57 4.54 0 6.61 4.13 6.61 8.39-.01 4.44-1.62 8.79-6.4 8.79z",
    fill: "#696B6B"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "#929290"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.99 47.01c-7.02 0-9.97 5.86-9.97 11.68 0 6.29 2.95 11.68 9.97 11.68 5.56 0 8.47-2.91 9.63-7.92h-2.7c-.86 3.34-3 5.65-6.93 5.65-5.18 0-7.23-4.75-7.27-8.69h16.99c.21-6.2-2.61-12.4-9.72-12.4zM2.72 57.15c.43-4.02 2.87-7.87 7.27-7.87 4.37 0 6.89 3.81 7.02 7.87H2.72zM49.96 52.83h-.08v-5.18H47.4v22.08h2.7V57.97c0-4.58 3.34-8.18 8.22-7.92v-2.7c-3.99-.17-6.99 1.93-8.36 5.48zM71.84 47.01c-3.13 0-6.08 1.8-7.06 4.45h-.08v-3.81H62v22.08h2.7V56.85c.08-4.32 2.65-7.58 6.93-7.58 4.36 0 5.61 2.87 5.61 6.67v13.78h2.7v-14.2c-.01-5.26-1.9-8.51-8.1-8.51zM38.84 48.29c-.1-.06-.19-.12-.29-.18-.1-.06-.82-.4-.93-.44-.09-.04-.85-.28-.94-.3-.09-.02-.18-.05-.27-.06-.28-.06-2.72-.3-2.99-.3-.18 0-.73.01-.83.02-.16.01-1.09.1-1.17.11-.12.01-.71.12-.79.13-.11.02-.97.24-1.09.28-.13.04-.94.35-1.2.48-.08.04-.6.33-.64.35-.08.05-.16.1-.23.15-.01.01-.33.23-.37.27-.07.05-.65.58-.7.64-.15.16-.51.6-.54.65-.07.09-.53.86-.57.95-.01.02-.12.26-.16.37-.01.02-.02.04-.02.06-.04.08-.16.41-.18.49-.01.03-.43 2.29-.44 2.45h2.7c.01-.2.02-.4.04-.59.01-.06.22-1.12.25-1.2 0-.01.5-1.25.92-1.62.04-.05.66-.6.73-.65.07-.05.77-.46 1.08-.58.05-.02 1.03-.31 1.23-.35.1-.02.4-.06.45-.07.29-.04 1.1-.07 1.21-.07 3.17 0 5.78.9 5.78 4.53 0 .57-.07 1.02-.2 1.39-.01.04-.28.53-.31.56a1.668 1.668 0 0 1-.42.38c-.09.06-.44.23-.52.26-.08.03-1.11.28-1.23.3-.06.01-2.5.3-2.76.33-.13.01-1.96.25-2.15.28-.06.01-1.93.35-1.96.36-.14.03-1.14.3-1.27.35-.01 0-1.48.61-1.6.68-.22.12-.43.25-.63.39-.1.07-1.02.92-1.11 1.03-.06.08-.57.89-.66 1.09-.03.07-.4 1.27-.45 1.77-.01.06-.01.11-.02.17 0 .03-.03.66-.03.76 0 4.45 3.34 6.46 7.4 6.46h2.48c1.91 0 3.9-.29 5.43-1.28 1.6-1.02 2.7-2.81 2.7-5.82v-9.16c-.03-3.01-1.13-4.8-2.73-5.82zm0 13.01v.08c-.01.38 0 1.77 0 2.19 0 3.64-2.61 4.53-5.78 4.53h-1.93c-2.53 0-4.92-1.67-4.92-4.36 0-.33.04-.64.1-.93.01-.05.02-.1.04-.15.01-.03.02-.06.03-.1.06-.19.13-.38.23-.55.02-.05.05-.09.08-.14.04-.07.08-.13.12-.2a3.757 3.757 0 0 1 .86-.86h.01c.03-.02.53-.34.77-.46.04-.02.09-.04.13-.06.09-.04.55-.23.57-.24.08-.03.29-.1.3-.11.04-.01 1.34-.37 1.47-.4.4-.09.8-.16 1.22-.23.41-.07.83-.13 1.25-.19.16-.02.96-.14 1.19-.17.05-.01.1-.01.14-.02.23-.03 1.11-.17 1.32-.2.15-.02.29-.05.43-.07.73-.13 1.93-.34 2.27-.99h.08v3.63h.02z"
  }))));
};

EarnUpLogoDTC.defaultProps = {
  width: "128",
  height: "79",
  viewBox: "0 0 128 79",
  xmlns: "http://www.w3.org/2000/svg"
};

var EarnUpLogoB2B = function EarnUpLogoB2B(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("title", null, "Logo/B2B"), /*#__PURE__*/_react["default"].createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M66.619.005s-.032.059-.09.176a5.317 5.317 0 0 1-.293.5 15.387 15.387 0 0 1-1.333 1.77 29.837 29.837 0 0 1-2.412 2.477 39.238 39.238 0 0 1-3.522 2.813 47.79 47.79 0 0 1-4.548 2.823c-1.668.914-3.495 1.76-5.413 2.562-.484.186-.972.378-1.466.57-.25.095-.495.185-.744.281-.25.085-.505.17-.76.26-.505.17-1.015.346-1.53.521l-1.562.463-.786.234-.797.207c-.531.139-1.068.271-1.604.41-1.079.244-2.162.478-3.252.701-2.183.394-4.377.74-6.55.957-1.084.107-2.162.229-3.23.277l-1.588.096c-.26.015-.526.026-.787.042l-.78.016-1.541.032c-.51.005-1.015.032-1.514.01-.999-.02-1.971-.037-2.922-.058-.95-.037-1.87-.096-2.762-.149-.447-.026-.882-.058-1.313-.085-.43-.042-.85-.08-1.259-.122-.823-.085-1.61-.165-2.358-.24-.75-.084-1.456-.19-2.12-.286-.664-.096-1.286-.181-1.86-.277-.573-.085-1.094-.197-1.572-.282-.946-.17-1.69-.33-2.194-.425-.505-.106-.776-.16-.776-.16s.276 0 .792-.005c.515.005 1.27-.005 2.226.021.956.032 2.12.011 3.448.011.664-.005 1.37.016 2.114.005.744-.01 1.525-.02 2.343-.037.409-.005.823-.005 1.248-.01l1.296-.048c.877-.038 1.785-.043 2.715-.09.93-.049 1.88-.102 2.858-.155.972-.058 1.966-.143 2.975-.218 2.019-.165 4.096-.383 6.195-.654 2.098-.27 4.218-.611 6.327-1.01 1.052-.202 2.098-.42 3.14-.654 1.03-.266 2.077-.462 3.086-.76 2.04-.516 4.006-1.154 5.908-1.786 1.88-.676 3.686-1.367 5.36-2.116a61.65 61.65 0 0 0 4.627-2.292 50.716 50.716 0 0 0 3.73-2.275 38.418 38.418 0 0 0 2.709-2.015c.722-.6 1.264-1.106 1.615-1.467.17-.181.308-.325.388-.426.09-.08.138-.133.138-.133z",
    fill: "#5668E8"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M52.673 25.328v7.926c0 1.425-.903 2.356-2.374 2.356h-1.09c-1.47 0-2.374-.93-2.374-2.356v-7.926h-1.923v7.698c0 2.515.95 4.28 4.027 4.28h1.63c3.082 0 4.028-1.765 4.028-4.28v-7.698h-1.924zM62.767 24.96c-1.556 0-3.007.586-3.618 1.915h-.042v-1.632h-1.865v16.699h1.865v-6.237h.042c.834 1.425 2.503 1.893 3.666 1.893 3.464 0 5.174-2.87 5.174-6.284 0-3.413-1.732-6.353-5.222-6.353zm-.149 10.889c-2.566 0-3.575-2.196-3.575-4.578 0-2.264.967-4.556 3.464-4.556 2.412 0 3.511 2.196 3.511 4.46-.005 2.361-.86 4.674-3.4 4.674z",
    fill: "#696B6B"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "#929290"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.307 24.993c-3.73 0-5.296 3.115-5.296 6.21 0 3.343 1.567 6.209 5.296 6.209 2.954 0 4.5-1.547 5.116-4.21H8.99c-.457 1.775-1.594 3.003-3.682 3.003-2.752 0-3.84-2.525-3.862-4.62h9.026c.111-3.296-1.387-6.592-5.164-6.592zm-3.862 5.39C1.673 28.247 2.97 26.2 5.307 26.2c2.322 0 3.66 2.026 3.73 4.185H1.445zM26.541 28.087H26.5v-2.754H25.18v11.739h1.435v-6.253c0-2.434 1.774-4.348 4.367-4.21v-1.436c-2.12-.09-3.714 1.026-4.442 2.914zM38.165 24.993c-1.663 0-3.23.957-3.75 2.365h-.043v-2.025h-1.434v11.739h1.434v-6.848c.042-2.297 1.408-4.03 3.681-4.03 2.317 0 2.98 1.526 2.98 3.546v7.326h1.435v-7.549c-.005-2.796-1.01-4.524-4.303-4.524zM20.634 25.673l-.154-.096a8.384 8.384 0 0 0-.494-.233 9.046 9.046 0 0 0-.5-.16c-.048-.01-.095-.027-.143-.032a27.226 27.226 0 0 0-1.589-.16c-.095 0-.387.006-.44.011-.086.006-.58.053-.622.059-.064.005-.377.064-.42.069-.058.01-.515.127-.579.149-.069.021-.5.186-.637.255-.043.021-.32.175-.34.186-.043.027-.085.053-.123.08-.005.005-.175.122-.196.143a7.635 7.635 0 0 0-.372.34c-.08.086-.27.32-.287.346a8.458 8.458 0 0 0-.303.505c-.005.01-.063.138-.085.197-.005.01-.01.021-.01.032a2.575 2.575 0 0 0-.096.26 47.747 47.747 0 0 0-.234 1.303h1.435c.005-.106.01-.213.02-.314.006-.032.118-.595.134-.638 0-.005.265-.664.489-.861.02-.027.35-.32.387-.346.037-.026.41-.244.574-.308.027-.01.547-.165.654-.186.053-.01.212-.032.239-.037.154-.022.584-.038.642-.038 1.684 0 3.071.479 3.071 2.409 0 .303-.037.542-.106.739a3.253 3.253 0 0 1-.165.298.887.887 0 0 1-.223.202 2.676 2.676 0 0 1-.276.138c-.043.016-.59.149-.654.16-.032.005-1.328.159-1.466.175a68.81 68.81 0 0 0-1.142.149c-.032.005-1.026.186-1.041.191-.075.016-.606.16-.675.186-.005 0-.786.324-.85.362a3.533 3.533 0 0 0-.335.207c-.053.037-.542.49-.59.548a7.852 7.852 0 0 0-.35.579c-.016.037-.213.675-.24.941-.005.032-.005.059-.01.09 0 .016-.016.351-.016.404 0 2.366 1.775 3.435 3.932 3.435h1.317c1.015 0 2.072-.154 2.885-.68.85-.543 1.434-1.495 1.434-3.095v-4.87c-.016-1.6-.6-2.552-1.45-3.094zm0 6.917v.042c-.006.202 0 .941 0 1.165 0 1.935-1.387 2.408-3.07 2.408h-1.026c-1.344 0-2.614-.888-2.614-2.318 0-.175.021-.34.053-.494.005-.027.01-.054.021-.08a1.417 1.417 0 0 1 .138-.346c.011-.026.027-.048.043-.074.021-.037.043-.07.064-.106a1.997 1.997 0 0 1 .457-.457h.005c.016-.011.282-.181.41-.245.02-.01.047-.021.068-.032.048-.021.292-.122.303-.128.042-.016.154-.053.16-.058.02-.005.711-.197.78-.213.213-.048.425-.085.648-.122.218-.037.441-.07.664-.101.085-.01.51-.075.633-.09.026-.006.053-.006.074-.011.122-.016.59-.09.701-.106.08-.011.154-.027.229-.038.387-.069 1.025-.18 1.206-.526h.042v1.93h.01z"
  }))));
};

EarnUpLogoB2B.defaultProps = {
  width: "68",
  height: "42",
  viewBox: "0 0 68 42",
  xmlns: "http://www.w3.org/2000/svg"
};
// header config types
var B2B = 'b2b';
exports.B2B = B2B;
var CUSTOM = 'custom';
exports.CUSTOM = CUSTOM;
var DTC = 'dtc';
exports.DTC = DTC;
var MARKETING = 'marketing'; // default routes

exports.MARKETING = MARKETING;
var HOME = '/';
var MAX_WIDTH = 1280;
var ABOUT = '/about';
var HOW_IT_WORKS = '/how-it-works';
var CAREERS = '/careers';
var PARTNER_WITH_US = '/partner-with-us';
var ENROLLMENT = 'https://enrollment.earnup.com/signup';
var LOGIN = 'https://my.earnup.com';

var styles = function styles(theme) {
  var _logoContainer;

  return {
    header: {
      zIndex: theme.zIndex && theme.zIndex.appBar,
      width: '100%',
      position: 'sticky',
      top: 0,
      left: 0,
      backgroundColor: function backgroundColor(props) {
        return (0, _theme.getBgColorByHeaderType)(theme, props.type);
      },
      boxShadow: function boxShadow(props) {
        return props.type === MARKETING ? 'none' : theme.shadows[3];
      }
    },
    headerContent: {
      maxWidth: function maxWidth(props) {
        return props.headerMaxWidth;
      },
      margin: 'auto',
      padding: theme.spacing(1)
    },
    logoContainer: (_logoContainer = {
      margin: function margin(props) {
        return theme.spacing(props.logoMargin[0], props.logoMargin[1], props.logoMargin[2], props.logoMargin[3]);
      }
    }, (0, _defineProperty2["default"])(_logoContainer, theme.breakpoints.down('sm'), {
      margin: 0
    }), (0, _defineProperty2["default"])(_logoContainer, "maxHeight", function maxHeight(props) {
      return props.logoHeight || 48;
    }), (0, _defineProperty2["default"])(_logoContainer, "maxWidth", function maxWidth(props) {
      return props.logoWidth || 64;
    }), _logoContainer),
    link: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    logo: {
      height: function height(props) {
        return props.logoHeight || 48;
      },
      width: function width(props) {
        return props.logoWidth || 64;
      }
    },
    navDesktop: (0, _defineProperty2["default"])({}, theme.breakpoints.down('sm'), {
      display: 'none'
    }),
    navMobile: (0, _defineProperty2["default"])({}, theme.breakpoints.up('md'), {
      display: 'none'
    })
  };
};

exports.styles = styles;
var defaultItems = [{
  name: 'how-it-works',
  buttonName: 'How it Works',
  route: HOW_IT_WORKS,
  variant: 'text'
}, {
  name: 'partner-with-us',
  buttonName: 'Partner With Us',
  route: PARTNER_WITH_US,
  variant: 'text'
}, {
  name: 'about',
  buttonName: 'About',
  route: ABOUT,
  variant: 'text'
}, {
  name: 'careers',
  buttonName: 'Careers',
  route: CAREERS,
  variant: 'text'
}, {
  name: 'sign-up',
  buttonName: 'Sign Up',
  route: ENROLLMENT,
  variant: 'contained'
}, {
  name: 'log-in',
  buttonName: 'Log In',
  route: LOGIN,
  variant: 'outlined'
}];

var getLogo = function getLogo(customLogoSrc) {
  var isSvg = typeof customLogoSrc !== 'string';

  if (isSvg) {
    return customLogoSrc;
  } else {
    return function () {
      return /*#__PURE__*/_react["default"].createElement("img", {
        src: customLogoSrc,
        alt: "logo",
        style: {
          maxWidth: '100%',
          maxHeight: '48px'
        }
      });
    };
  }
};

var defaultType = MARKETING;
var defaultLogoTo = HOME;
var defaultAlignItems = 'center';
var defaultLogoMargin = [0, 0, 0, 7];
var defaultNavMargin = [0, 8, 0, 8];
var defaultNavJustify = 'flex-end';
var defaultSiteLinks = _SiteLinks.SiteLinks;
var defaultSocialLinks = _SocialLinks.SocialLinks;
var defaultEmailUs = _EmailUs.EmailUs;
var defaultOverrideFooter = undefined;
var defaultOtherRightContent = undefined;
var useStyles = (0, _makeStyles["default"])(styles);

var Header = function Header(_ref) {
  var _configMap;

  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? defaultType : _ref$type,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? defaultItems : _ref$items,
      _ref$highlightActive = _ref.highlightActive,
      highlightActive = _ref$highlightActive === void 0 ? false : _ref$highlightActive,
      _ref$activeItemName = _ref.activeItemName,
      activeItemName = _ref$activeItemName === void 0 ? defaultItems[0].name : _ref$activeItemName,
      _ref$customLogoSrc = _ref.customLogoSrc,
      customLogoSrc = _ref$customLogoSrc === void 0 ? EarnUpLogoDTC : _ref$customLogoSrc,
      logoWidth = _ref.logoWidth,
      logoHeight = _ref.logoHeight,
      _ref$logoTo = _ref.logoTo,
      logoTo = _ref$logoTo === void 0 ? defaultLogoTo : _ref$logoTo,
      _ref$Nav = _ref.Nav,
      Nav = _ref$Nav === void 0 ? _Nav["default"] : _ref$Nav,
      _ref$NavMobile = _ref.NavMobile,
      NavMobile = _ref$NavMobile === void 0 ? _NavMobile["default"] : _ref$NavMobile,
      _ref$Link = _ref.Link,
      Link = _ref$Link === void 0 ? _TrackingLink["default"] : _ref$Link,
      _ref$alignItems = _ref.alignItems,
      alignItems = _ref$alignItems === void 0 ? defaultAlignItems : _ref$alignItems,
      _ref$logoMargin = _ref.logoMargin,
      logoMargin = _ref$logoMargin === void 0 ? defaultLogoMargin : _ref$logoMargin,
      _ref$navMargin = _ref.navMargin,
      navMargin = _ref$navMargin === void 0 ? defaultNavMargin : _ref$navMargin,
      _ref$navJustify = _ref.navJustify,
      navJustify = _ref$navJustify === void 0 ? defaultNavJustify : _ref$navJustify,
      _ref$SiteLinks = _ref.SiteLinks,
      SiteLinks = _ref$SiteLinks === void 0 ? defaultSiteLinks : _ref$SiteLinks,
      _ref$SocialLinks = _ref.SocialLinks,
      SocialLinks = _ref$SocialLinks === void 0 ? defaultSocialLinks : _ref$SocialLinks,
      _ref$EmailUs = _ref.EmailUs,
      EmailUs = _ref$EmailUs === void 0 ? defaultEmailUs : _ref$EmailUs,
      _ref$overrideFooter = _ref.overrideFooter,
      overrideFooter = _ref$overrideFooter === void 0 ? defaultOverrideFooter : _ref$overrideFooter,
      _ref$headerMaxWidth = _ref.headerMaxWidth,
      headerMaxWidth = _ref$headerMaxWidth === void 0 ? MAX_WIDTH : _ref$headerMaxWidth,
      mobileLogoWidth = _ref.mobileLogoWidth,
      _ref$isPartner = _ref.isPartner,
      isPartner = _ref$isPartner === void 0 ? false : _ref$isPartner,
      _ref$OtherRightConten = _ref.OtherRightContent,
      OtherRightContent = _ref$OtherRightConten === void 0 ? defaultOtherRightContent : _ref$OtherRightConten;
  var classes = useStyles({
    logoMargin: logoMargin,
    type: type,
    logoHeight: logoHeight,
    logoWidth: logoWidth,
    headerMaxWidth: headerMaxWidth
  }); // determine header config

  var configMap = (_configMap = {}, (0, _defineProperty2["default"])(_configMap, CUSTOM, {
    Logo: getLogo(customLogoSrc),
    contrastBg: false
  }), (0, _defineProperty2["default"])(_configMap, B2B, {
    Logo: EarnUpLogoB2B,
    contrastBg: false
  }), (0, _defineProperty2["default"])(_configMap, DTC, {
    Logo: EarnUpLogoDTC,
    contrastBg: false
  }), (0, _defineProperty2["default"])(_configMap, MARKETING, {
    Logo: EarnUpLogoWhite,
    contrastBg: true
  }), _configMap);
  var config = configMap[type];
  var Logo = config.Logo,
      contrastBg = config.contrastBg;
  return /*#__PURE__*/_react["default"].createElement("header", {
    className: classes.header
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    container: true,
    wrap: "nowrap",
    justify: "space-between",
    alignItems: alignItems,
    className: classes.headerContent
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    container: true,
    item: true,
    justify: "center",
    alignItems: "center",
    className: classes.logoContainer
  }, /*#__PURE__*/_react["default"].createElement(Link, {
    className: classes.link,
    to: logoTo
  }, /*#__PURE__*/_react["default"].createElement(Logo, {
    className: classes.logo
  }))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    container: true,
    item: true,
    className: classes.navDesktop
  }, /*#__PURE__*/_react["default"].createElement(Nav, {
    type: type,
    items: items,
    highlightActive: highlightActive,
    activeItemName: activeItemName,
    Link: Link,
    contrastBg: contrastBg,
    navMargin: navMargin,
    navJustify: navJustify
  })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    className: classes.navDesktop
  }, OtherRightContent), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    className: classes.navMobile
  }, /*#__PURE__*/_react["default"].createElement(NavMobile, {
    type: type,
    Logo: Logo,
    contrastBg: contrastBg,
    items: items,
    Link: Link,
    SiteLinks: SiteLinks,
    SocialLinks: SocialLinks,
    EmailUs: EmailUs,
    overrideFooter: overrideFooter,
    mobileLogoWidth: mobileLogoWidth,
    isPartner: isPartner
  }))));
};

exports.Header = Header;

var customMargin = function customMargin(props, propName, componentName) {
  var prop = props[propName];

  if (prop && (!Array.isArray(prop) || prop.length !== 4 || !prop.every(Number.isInteger))) {
    return new Error("Invalid prop '".concat(propName, "' supplied to '").concat(componentName, "'. Expected array of length 4, containing only numbers."));
  }

  return null;
};

Header.propTypes = {
  /** Header type to determine logo and header background */
  type: _propTypes["default"].oneOf([B2B, CUSTOM, DTC, MARKETING]),

  /** Header item's corresponding route */
  logoTo: _propTypes["default"].string,

  /** If 'true', Header will indicate which header item (or reoute) is currently displayed */
  highlightActive: _propTypes["default"].bool,

  /** Name of active header item */
  activeItemName: _propTypes["default"].string,

  /** List of navigation items */
  items: _propTypes["default"].array,

  /** Grid justify value */
  justify: _propTypes["default"].oneOf(['flex-start', 'center', 'flex-end', 'space-between', 'space-around', 'space-evenly']),

  /** Grid alignItems value */
  alignItems: _propTypes["default"].oneOf(['flex-start', 'center', 'flex-end', 'stretch', 'baseline']),

  /** Array of logo link margin values */
  logoMargin: customMargin,

  /** Array of nav item margin values */
  navMargin: customMargin,

  /** Component to override default footer */
  overrideFooter: _propTypes["default"].node,

  /** Header max width */
  headerMaxWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
};
var _default = Header;
exports["default"] = _default;